<template>
  <div id="photos">
      <v-container>
        <span v-if="language==='RU'"><PageTitle :title="title_RU"  class="mt-4" /></span>
        <span v-if="language==='EN'"><PageTitle :title="title_EN"  class="mt-4" /></span>        
      <PhotoBlock />
    </v-container>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  import PhotoBlock from '@/components/PhotoBlock'

    export default {
      name: 'Photos',
        components: { PageTitle, PhotoBlock },
          data() {
            return {
              language: '',
              title_RU: 'Фотографии',
              title_EN: 'Photos'
            }
          },
    mounted(){
      if(localStorage.lang){
        this.language = localStorage.lang
      }
    }
  }
</script>


